import React from 'react';
import {Text, View} from 'react-native';
import {Table} from '../../../shared/components/table';
import {Column} from '../../../shared/components/table/model';
import {useStyles} from '../../../shared/hooks/styles';
import {PassInfo} from '../../../shared/models/api/skipassResponsePayload';
import {DeviceSize} from '../../../shared/theme/helpers';
import {formatDateTime} from '../../../shared/utils/formatDate';

interface LiftingsTableProps {
  data: PassInfo[] | undefined;
}

export function LiftingsTable({data}: LiftingsTableProps) {
  const styles = useStyles(({mediaOnly, theme}) => ({
    tableContainer: {
      ...mediaOnly(DeviceSize.desktop, {width: '80%'}),
    },
    colText: {
      ...theme.fonts.body,
      color: theme.color.textColor,
    },
    textCenter: {
      textAlign: 'center',
    },
    textRight: {
      textAlign: 'right',
    },
  }));

  const columns: Column<PassInfo>[] = [
    {
      title: 'Наименование',
      field: 'facilityName',
      headStyles: {
        colHeadStyle: {flexBasis: '60%'},
      },
      styles: {
        colBodyTextStyle: styles.colText,
        colBodyStyle: {flexBasis: '60%'},
      },
    },
    {
      title: 'Дата и время',
      field: 'date',
      render: (row) => {
        return <Text style={[styles.colText, styles.textCenter]}>{formatDateTime(row.date)}</Text>;
      },
      headStyles: {
        colHeadTextStyle: styles.textCenter,
        colHeadStyle: {flexBasis: '25%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '25%'},
      },
    },
    {
      title: 'Количество',
      field: 'payments',
      render: (row) => {
        return <Text style={[styles.colText, styles.textRight]}>{row.payments.length}</Text>;
      },
      headStyles: {
        colHeadTextStyle: styles.textRight,
        colHeadStyle: {flexBasis: '15%'},
      },
      styles: {
        colBodyStyle: {flexBasis: '15%'},
      },
    },
  ];

  return (
    <View style={styles.tableContainer}>
      <Table data={data} columns={columns} />
    </View>
  );
}
